import { FC, PropsWithChildren } from 'react';
import { useIsMobile } from '@src/application/hooks/useIsMobile';

export const Desktop: FC<PropsWithChildren> = ({ children }) => (!useIsMobile() ? children : null);

export const Mobile: FC<PropsWithChildren> = ({ children }) => (useIsMobile() ? children : null);
